var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[_c('vx-card',{class:_vm.currentBg},[_c('h1',{staticClass:"rg-big-title extrabold"},[_vm._t("text")],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }